import { AvatarSex } from '@seddi/avatar';
import { Garment } from './garmentTypes';

export enum StyleGender {
  Female = 'FEMALE',
  Male = 'MALE',
  GenderLess = 'GENDERLESS',
}

export type Style = {
  id: string;
  brand?: string;
  code?: string;
  description?: string;
  gender?: StyleGender;
  name: string;
  retailer?: string;
  taxonomy: string;
  type0: string;
  variants: Garment[];
  orgId: string;
  userId: string;
  createdAt: Date;
  updatedAt: Date;
};

export type GarmentSummary = {
  id: string;
  avatarSex: AvatarSex;
  avatarSmplShape: number[];
  priority: number;
  preview: string;
  variant: string;
};

export type StyleSummary = {
  id: string;
  brand: string;
  name: string;
  variants: GarmentSummary[];
};

export type SizeRecommendation = {
  size: string;
};
